import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AssessmentGroupInfo } from 'app/models/evaluation/assessment-group-info.model';

@Component({
  selector: 'app-one-to-four-scale',
  templateUrl: './one-to-four-scale.component.html',
  styleUrls: ['./one-to-four-scale.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => OneToFourScaleComponent),
    multi: true
  }]
})
export class OneToFourScaleComponent implements ControlValueAccessor {
  @Input() disabled = false;
  @Input() display = false;

  @Input() assessmentGroups: AssessmentGroupInfo[] = [];

  _value: string;

  onChange = (_: any) => {};
  onTouched = () => {};

  constructor() {
    this._value = '0';
    this.assessmentGroups = [];
  }

  get value(): string {
    return this._value;
  }

  set value(val: string) {
    if (val !== this._value) {
      this._value = val;
      this.onChange(val);
    }
  }

  select(index: any) {
    if (this.disabled || this.display) { return; }
    this.value = index;
  }

  writeValue(value: string) {
    if (value === '1' || value === '2' || value === '3' || value === '4') {
      this.value = value;
    } else {
      this.value = '0';
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }
}
